import React from 'react';

import "./ArchiveMoney.css";





const ArchiveMoney: React.FC = () => {



   return (

      <div className="card card_archive_money">
      <div className="content">
         <div className="front">
            <h3 className="title">Total amount donated to charity</h3>
            <p className="subtitle">Hover me :</p>
         </div>

         <div className="back">
            <p className="description">
               1900 uah
            </p>
         </div>
      </div>
   </div>
   );
}

export default ArchiveMoney;
